import React, { Component } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { isEmpty, cloneDeep } from 'lodash';
import moment from 'moment';
import PageTitle from '../../../../components/PageTitle';
import RouteNames from '../../../App/RouteNames';
import { uploadMultiPartFiles, saveOutputTemplateByType, getOutputTemplateByType } from '../../../App/actions';
import TitleFrom from '../../../../components/common/TitleFrom';
import { ObjectFilesSummarySearchForm } from '../../../../components/ReportHub';
import {
  SwitchExport,
  DataTable,
  ExcelExport,
  TablePagination,
  ButtonExport,
  EmailGroup,
  DragDropConfigExportTemplate,
  ModalWithItem,
} from '../../../../components/common';
import { tabelColumnExportBillObjectFilesSummary, sortBillObjectFilesSummary } from '../../constants';
import { getObjectFilesReport, getAllObjectFilesReport } from '../../actions';
import { makeGetListObjectFiles, makeGetListAllObjectFiles } from '../../selectors';
import {
  getPageTotalCount,
  parseToMutationRequestPostMethod,
  blobToFile,
  validateEmail,
  blobToCSVFile,
  configOutputTemplateByType,
} from '../../../../utils/utils';
import convertJson2Sheet from '../../../../utils/ExcelHelper/exportExcelFile';
import convertJson2Pdf from '../../../../utils/PdfHelper/exportPdfFile';
import { PAGE_SIZE_DOWNLOAD } from '../../../../utils/constants';

let tableColumnsOutput = null;

class ObjectFilesSummary extends Component {
  state = {
    isActivePdf: false,
    page: 0,
    size: 20,
    filter: {},
    sort: '',
    sorted: {},
    totalCount: null,
    isSearching: false,
    listBillObjectFiles: [],
  };

  buttonRef = React.createRef();

  static getDerivedStateFromProps(props, state) {
    return {
      listBillObjectFiles: props.listBillObjectFiles,
      totalCount: getPageTotalCount({ ...state, items: props.listBillObjectFiles }),
    };
  }

  componentDidMount() {
    const {
      permissions: { modeGetObjectFiles },
    } = this.props;
    if (modeGetObjectFiles) {
      this.doGetListBillObjectFiles();
      this.doGetOutputTemplateByType();
    }
  }

  onSortColumn = (sortCol, sortDir) => {
    this.setState({ sorted: { sortCol, sortDir } }, () => {
      this.doGetListBillObjectFiles();
    });
  };

  onPageChange = page => {
    this.setState({ page }, () => this.doGetListBillObjectFiles());
  };

  onSizeChange = size => {
    this.setState({ size, page: 0 }, () => this.doGetListBillObjectFiles());
  };

  onHandleSubmitSearch = filter => {
    this.setState({ filter: { ...filter }, page: 0 }, () => {
      this.doGetListBillObjectFiles();
    });
  };

  doGetListBillObjectFiles = () => {
    const { filter, page, size, sorted } = this.state;
    const { getObjectFilesReport } = this.props;
    const newFilter = cloneDeep(filter);
    if (!newFilter.startYearMonth)
      newFilter.startYearMonth = moment(new Date())
        .subtract(1, 'months')
        .format('YYYY-MM');
    if (!newFilter.endYearMonth) newFilter.endYearMonth = moment(new Date()).format('YYYY-MM');

    const payload = {
      page: page + 1,
      size,
      filter: newFilter,
      sort:
        !isEmpty(sorted) && sortBillObjectFilesSummary[sorted.sortCol]
          ? sortBillObjectFilesSummary[sorted.sortCol][sorted.sortDir]
          : null,
    };
    this.setState({ isSearching: true });
    getObjectFilesReport(payload, () => {
      this.setState({ isSearching: false });
    });
  };

  doGetAlllistBillObjectFiles = cb => {
    const { filter, sorted } = this.state;
    const { getAllObjectFilesReport } = this.props;
    const newFilter = cloneDeep(filter);

    if (!newFilter.startYearMonth)
      newFilter.startYearMonth = moment(new Date())
        .subtract(1, 'months')
        .format('YYYY-MM');
    if (!newFilter.endYearMonth) newFilter.endYearMonth = moment(new Date()).format('YYYY-MM');

    const payload = {
      page: 1,
      size: PAGE_SIZE_DOWNLOAD,
      filter: newFilter,
      sort: !isEmpty(sorted) ? sortBillObjectFilesSummary[sorted.sortCol][sorted.sortDir] : null,
    };
    getAllObjectFilesReport(payload, () => {
      if (cb) cb();
    });
  };

  onChangeSwitch = () => {
    const { isActivePdf } = this.state;
    this.setState({ isActivePdf: !isActivePdf });
  };

  onExport = () => {
    this.doGetAlllistBillObjectFiles(() => {
      const { isActivePdf } = this.state;
      if (isActivePdf) {
        const { listAllBillObjectFiles, t } = this.props;
        convertJson2Pdf({
          data: listAllBillObjectFiles,
          t,
          title: t('reportPage:sidebar.folioCount').toLocaleUpperCase(),
          fileName: `${t('reportPage:sidebar.folioCount')
            .toLocaleLowerCase()
            .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`,
          columnsTable: tableColumnsOutput,
          fontSize: 10,
        });
      } else {
        this.buttonRef.current.click();
      }
    });
  };

  sendEmail = ({ subject, emailBody }) => {
    this.doGetAlllistBillObjectFiles(() => {
      const { listAllBillObjectFiles, t, uploadMultiPartFiles } = this.props;
      const { emails, isActivePdf } = this.state;

      const query = `{"query": "mutation{sendReport(input: ${parseToMutationRequestPostMethod(
        {
          emailAddress: emails.join(', '),
          type: 'GET_OBJECT_FILES_REPORT',
          subject: subject || `Embrix Report ${t('reportPage:sidebar.folioCount')}`,
          emailBody,
        },
        ['type']
      )})}"}`;
      const formData = new FormData();

      if (!isActivePdf) {
        formData.append(
          'file',
          blobToCSVFile({
            fileName: `${t('reportPage:sidebar.folioCount')
              .toLocaleLowerCase()
              .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}.csv`,
            data: listAllBillObjectFiles,
            t,
            columns: tableColumnsOutput,
            listOptionFields: {
              documentType: 'documentType',
            },
          })
        );
      } else {
        const pdfFile = convertJson2Pdf({
          data: listAllBillObjectFiles,
          t,
          title: t('reportPage:sidebar.folioCount').toLocaleUpperCase(),
          fileName: `${t('reportPage:sidebar.folioCount')
            .toLocaleLowerCase()
            .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`,
          isFile: true,
          columnsTable: tableColumnsOutput,
          fontSize: 10,
        });
        formData.append(
          'file',
          blobToFile(
            pdfFile,
            `${t('reportPage:sidebar.folioCount')
              .toLocaleLowerCase()
              .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`
          )
        );
      }

      formData.append('graphql', query);
      // formData.append('file', blobToFile(pdfFile, 'attachment'));
      uploadMultiPartFiles(
        formData,
        res => {
          if (res && res.success) {
            if (res.success) this.setState({ emails: [] });
          }
        },
        true
      );
    });
  };

  onChangeEmail = tags => {
    let isEmail = true;
    if (tags && tags.length) {
      tags.forEach(email => {
        if (!validateEmail(email)) {
          isEmail = false;
        }
      });
    }
    if (!isEmail) return '';

    return this.setState({ emails: tags });
  };

  doGetOutputTemplateByType = () => {
    const { getOutputTemplateByType, t } = this.props;
    getOutputTemplateByType('OBJECT_FILES_SUMMARY_REPORT', ({ success, data }) => {
      if (success && data) {
        this.setState({
          exportColumnsSave: configOutputTemplateByType({
            columns: tabelColumnExportBillObjectFilesSummary,
            data,
            t,
          }),
          idOutputTemplate: data?.id,
          typeOutputTemplate: data?.type,
        });
      }
    });
  };

  onHandleSaveConfig = columns => {
    const { saveOutputTemplateByType } = this.props;
    const { idOutputTemplate, typeOutputTemplate } = this.state;
    const payload = {
      id: idOutputTemplate,
      type: typeOutputTemplate,
      source: columns.sourceFields.items.map((val, index) => {
        return { name: val.name, index: index + 1 };
      }),
      target: columns.targetFields.items.map((val, index) => {
        return { name: val.name, index: index + 1 };
      }),
    };

    saveOutputTemplateByType(payload, ({ success }) => {
      if (success) {
        this.doGetOutputTemplateByType();
        this.setState({ exportColumnsSave: columns, isOpenModalExportConfig: false });
      }
    });
  };

  onToggleModalExportConfig = () => {
    const { isOpenModalExportConfig } = this.state;
    this.setState({ isOpenModalExportConfig: !isOpenModalExportConfig });
  };

  render() {
    const {
      isSearching,
      isActivePdf,
      sorted,
      page,
      size,
      totalCount,
      listBillObjectFiles,
      emails,
      exportColumnsSave,
      isOpenModalExportConfig,
    } = this.state;
    const {
      listAllBillObjectFiles,
      t,
      permissions: { modeGetObjectFiles, modeDownloadReport, modeGetMailReport },
    } = this.props;
    if (!modeGetObjectFiles) return '';
    const exportColumns = exportColumnsSave || {};
    tableColumnsOutput = exportColumns?.targetFields?.items || [];
    return (
      <div className="col-md-12">
        <PageTitle
          linkTo={RouteNames.report.path}
          titleBtn="back"
          items={[
            { name: t('label.report'), url: RouteNames.report.path },
            { name: t('reportPage:sidebar.folioCount') },
          ]}
        />
        <br />
        <div className="card card-statistics mb-30">
          <TitleFrom title={t('reportPage:sidebar.folioCount')} />
          <div className="col-md-12 mb-30">
            <div className="card-body">
              <div className="pl-2">
                <ObjectFilesSummarySearchForm onSubmit={this.onHandleSubmitSearch} />
              </div>
              <div>
                <div className="mt-3 col-md-12 row mb-4 pt-3 pb-3">
                  <button
                    type="submit"
                    onClick={this.onToggleModalExportConfig}
                    className="button x-small mr-2 btn-config"
                  >
                    {/* {t('label.outputConfig')} */}
                    <i className="ti-list" />
                  </button>
                  {!!modeDownloadReport && (
                    <div className="ml-auto mt-2 mb-auto mr-3">
                      <SwitchExport
                        onChange={this.onChangeSwitch}
                        wrapperClass={isActivePdf ? 'switch-active' : 'switch-non-active'}
                        title={t('label.excel')}
                        checked={isActivePdf}
                        rightTitle={t('label.pdf')}
                      />
                    </div>
                  )}
                  {!!modeDownloadReport && (
                    <>
                      <ButtonExport onExport={this.onExport} />
                      <ExcelExport
                        element={<button type="button" className="display-none" ref={this.buttonRef} />}
                        nameSheet={t('reportPage:sidebar.folioCount').toLocaleUpperCase()}
                        multiDataSet={convertJson2Sheet({
                          data: listAllBillObjectFiles,
                          t,
                          title: t('reportPage:sidebar.folioCount').toLocaleUpperCase(),
                          columnsTable: tableColumnsOutput,
                        })}
                        fileName={`${t('reportPage:sidebar.folioCount')
                          .toLocaleLowerCase()
                          .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`}
                      />
                    </>
                  )}
                  {modeGetMailReport !== 0 && (
                    <EmailGroup
                      emails={emails}
                      onChangeEmail={this.onChangeEmail}
                      sendEmail={this.sendEmail}
                      data={listBillObjectFiles}
                    />
                  )}
                </div>
                <DataTable
                  columns={tableColumnsOutput}
                  data={listBillObjectFiles && listBillObjectFiles.length ? listBillObjectFiles : []}
                  onSort={this.onSortColumn}
                  sorted={sorted}
                  isLoading={isSearching}
                  isFixedHeaderTable
                />
              </div>
            </div>
          </div>
        </div>
        <div className="mb-30">
          <TablePagination
            pageNumber={page}
            pageSize={size}
            totalCount={totalCount}
            onPageChange={this.onPageChange}
            onSizeChange={this.onSizeChange}
          />
        </div>
        <ModalWithItem
          onToggle={this.onToggleModalExportConfig}
          isOpen={isOpenModalExportConfig}
          wrapperClass="modal-config"
        >
          <div className="col-md-12 d-flex">
            <div className="column-config" onClick={this.onToggleModalExportConfig} />
            <div className="body-config">
              <DragDropConfigExportTemplate
                onHandleSave={this.onHandleSaveConfig}
                exportColumns={exportColumns}
                onToggle={this.onToggleModalExportConfig}
              />
            </div>
          </div>
        </ModalWithItem>
      </div>
    );
  }
}

ObjectFilesSummary.propTypes = {
  getObjectFilesReport: PropTypes.func,
  getAllObjectFilesReport: PropTypes.func,
  listAllBillObjectFiles: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.any), PropTypes.objectOf(PropTypes.any)]),
};

ObjectFilesSummary.defaultProps = {
  getObjectFilesReport: () => {},
  getAllObjectFilesReport: () => {},
  listAllBillObjectFiles: [],
};

const mapStateToProps = createStructuredSelector({
  listBillObjectFiles: makeGetListObjectFiles() || [],
  listAllBillObjectFiles: makeGetListAllObjectFiles() || [],
});
export default withTranslation('common')(
  connect(mapStateToProps, {
    getObjectFilesReport,
    getAllObjectFilesReport,
    uploadMultiPartFiles,
    saveOutputTemplateByType,
    getOutputTemplateByType,
  })(ObjectFilesSummary)
);
